/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2022 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import React from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import {
  Dialog,
  withStyles,
  IconButton,
  Typography
} from '@material-ui/core';

import DialogCloseIcon from '@material-ui/icons/Close';
import * as shapes from '../shapes';

/**
 * External viewer for Iframe load
 *
 * @author Ashish Kumar
 */
const Styles = () => ({
  iframeWrapper: {
    height: '100%',
    width: '100%'
  },
  dialogWrapper: {
    backgroundColor: '#f7f7f7'
  },
  dialogTitle: {
    textAlign: 'left',
    padding: '15px 0px',
    marginLeft: '25%'
  },
  closeButton: {
    position: 'absolute',
    right: 20,
    top: 20
  }
});

const ExternalViewer = ({
  classes,
  language,
  open,
  openExternalViewer,
  iframeUrl,
  title,
  heading
}) => (
  <Dialog
    open={open}
    fullScreen
    id="external-viewer-popup"
    aria-labelledby="external-viewer-popup-title"
    aria-describedby="external-viewer-popup-description"
    onClose={openExternalViewer}
    classes={{ paper: classes.dialogWrapper }}
  >
    <IconButton
      id="external-viewer"
      className={classes.closeButton}
      onClick={openExternalViewer}
    >
      <DialogCloseIcon />
    </IconButton>
    <Typography variant="h2" className={classes.dialogTitle}>
      { heading || language.getMessage('header.help.CUSTOMER_SUPPORT') }
    </Typography>
    <iframe
      src={iframeUrl}
      title={title}
      frameBorder="0"
      className={classes.iframeWrapper}
    />
  </Dialog>
);

ExternalViewer.propTypes = {
  classes: PropTypes.object.isRequired,
  language: shapes.language.isRequired,
  openExternalViewer: PropTypes.func,
  open: PropTypes.bool,
  iframeUrl: PropTypes.string.isRequired,
  title: PropTypes.string,
  heading: PropTypes.string
};
ExternalViewer.defaultProps = {
  open: false,
  openExternalViewer: () => {},
  title: 'External Viewer',
  heading: 'Customer Support'
};

export default withStyles(Styles)(inject('language')(observer(ExternalViewer)));
